var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import groupBy from 'lodash/groupBy';
import { defineComponent } from 'vue';
import apiService from '@/services/';
import { generateSaveQuery } from '@/plugins/helper';
export default defineComponent({
    data: function () {
        var _a = this.$route.query, area = _a.area, tags = _a.tags;
        var filterData = this.getFilterDataFromQuery(area, tags);
        var areaguideEvents = [];
        var areaguideSettings = null;
        return {
            filterData: filterData,
            areaguideEvents: areaguideEvents,
            areaguideSettings: areaguideSettings
        };
    },
    fetchOnServer: false,
    fetch: function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var settingResponse, events, eventResponse;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, apiService.getAreaguideSetting()];
                    case 1:
                        settingResponse = _g.sent();
                        this.areaguideSettings = ((_a = settingResponse.data) === null || _a === void 0 ? void 0 : _a.data) || null;
                        events = (_d = (_c = (_b = this.areaguideSettings) === null || _b === void 0 ? void 0 : _b.events) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.map(function (item) { return item.sys.id; });
                        return [4 /*yield*/, apiService.getAreaguideEvents()];
                    case 2:
                        eventResponse = _g.sent();
                        this.areaguideEvents = ((_f = (_e = eventResponse.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.filter(function (item) { return events.includes(item.sys.id); })) || [];
                        return [2 /*return*/];
                }
            });
        });
    },
    // head () {
    //   const title: string = '会場ガイド │ BALLPARK FANTASIA supported by Billboard Live YOKOHAMA（ボールパークファンタジア）'
    //   const description: string = 'BALLPARK FANTASIAの会場ガイドをご案内しています。今年で3回目となる大規模イルミネーションイベント「ボールパークファンタジア」。今年は「光と音楽」をテーマに実施エリアを拡大。周辺エリアのライトアップに加え、「光と音」をテーマにパワーアップしたコンテンツをお届けします。'
    //   const meta = this.$helper.setMetaTitleAndDescription(title, description)
    //   return {
    //     title,
    //     meta
    //   }
    // },
    computed: {
        eventSettings: function () {
            var _this = this;
            var _a, _b, _c;
            return (_c = (_b = (_a = this.areaguideSettings) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(function (item) { return _this.areaguideEvents.find(function (e) { var _a, _b; return ((_a = e === null || e === void 0 ? void 0 : e.sys) === null || _a === void 0 ? void 0 : _a.id) === ((_b = item === null || item === void 0 ? void 0 : item.sys) === null || _b === void 0 ? void 0 : _b.id); }); });
        },
        programsFiltered: function () {
            var _this = this;
            if (!this.filterData || !this.eventSettings) {
                return this.eventSettings;
            }
            return this.eventSettings.filter(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                if (_this.filterData.tags.length === 0 && !((_a = _this.filterData) === null || _a === void 0 ? void 0 : _a.area)) {
                    return true;
                }
                if (_this.filterData.tags.length === 0) {
                    return ((_b = _this.filterData) === null || _b === void 0 ? void 0 : _b.area) === generateSaveQuery(((_c = item === null || item === void 0 ? void 0 : item.area) === null || _c === void 0 ? void 0 : _c.sortParameter) || '') || ((_d = _this.filterData) === null || _d === void 0 ? void 0 : _d.area) === ((_e = item === null || item === void 0 ? void 0 : item.area) === null || _e === void 0 ? void 0 : _e.areaName);
                }
                // AND condition
                var allTags = ((_f = item === null || item === void 0 ? void 0 : item.tags) === null || _f === void 0 ? void 0 : _f.items.map(function (tag) { return tag.sortParameter ? generateSaveQuery(tag.sortParameter) : tag.tagName; })) || [];
                var matchedTags = _this.filterData.tags.map(function (tag) { return allTags.includes(tag); }).reduce(function (a, c) { return a && c; });
                // OR condition
                // const matchedTags = item?.tags?.items.filter(tag => this.filterData.tags.includes(generateSaveQuery(tag.sortParameter || '')) || this.filterData.tags.includes(tag.tagName)).length > 0
                if (!_this.filterData.area) {
                    return matchedTags;
                }
                return matchedTags && (((_g = _this.filterData) === null || _g === void 0 ? void 0 : _g.area) === generateSaveQuery(((_h = item === null || item === void 0 ? void 0 : item.area) === null || _h === void 0 ? void 0 : _h.sortParameter) || '') || ((_j = _this.filterData) === null || _j === void 0 ? void 0 : _j.area) === ((_k = item === null || item === void 0 ? void 0 : item.area) === null || _k === void 0 ? void 0 : _k.areaName));
            });
        },
        allTags: function () {
            var _a, _b;
            return ((_b = (_a = this.areaguideSettings) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.items) || [];
        },
        allAreas: function () {
            var _a, _b;
            return ((_b = (_a = this.areaguideSettings) === null || _a === void 0 ? void 0 : _a.areas) === null || _b === void 0 ? void 0 : _b.items) || [];
        },
        activeTagName: function () {
            return Object.keys(groupBy(this.areaguideEvents, 'area.areaName'));
        }
    },
    watch: {
        '$route.query': function (newValue) {
            var area = newValue.area, tags = newValue.tags;
            this.filterData = this.getFilterDataFromQuery(area, tags);
        },
        areaguideEvents: function () {
            var _this = this;
            this.$nuxt.$loading.finish();
            window.setTimeout(function () {
                _this.checkLocation();
            }, 500);
        }
    },
    mounted: function () {
        var _this = this;
        this.$nextTick(function () {
            window.scrollTo(0, 0);
            _this.$nuxt.$loading.start();
        });
    },
    methods: {
        getFilterDataFromQuery: function (area, tags) {
            var tagArray = tags ? decodeURIComponent(tags).split(',') : [];
            return {
                area: generateSaveQuery(area || ''),
                tags: tagArray
            };
        },
        checkLocation: function () {
            var event = this.$route.query.event;
            if (!event) {
                return;
            }
            var id = "#" + event + "_event";
            var element = document.querySelector(id);
            if (!element) {
                return;
            }
            this.$scrollTo(id, {
                duration: 500,
                offset: -100
            });
        }
    }
});
